export default __webpack_public_path__ + "static/media/P102.1.8e852d86.mp3";